import { FeedbackLayout } from '@/components/ui/feedback'

import { FeedbackNetworkError } from './network-error'
import { FeedbackUnknownError } from './unknown-error'

export type FeedbackErrorType = 'NETWORK_ERROR' | 'UNKNOWN_ERROR'

interface FeedbackErrorProps {
  errorType: FeedbackErrorType
  layout?: FeedbackLayout
  eventId?: string
  onRetry?: VoidFunction
  isRetrying?: boolean
  showReportButton?: boolean
}

export function FeedbackError({
  errorType,
  layout = 'default',
  eventId,
  onRetry,
  isRetrying = false,
  showReportButton = false,
}: FeedbackErrorProps) {
  if (errorType === 'NETWORK_ERROR') {
    return (
      <FeedbackNetworkError
        layout={layout}
        eventId={eventId}
        onRetry={onRetry}
        isRetrying={isRetrying}
      />
    )
  }

  return (
    <FeedbackUnknownError
      layout={layout}
      eventId={eventId}
      onRetry={onRetry}
      isRetrying={isRetrying}
      showReportButton={showReportButton}
    />
  )
}
